/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteAnalyticsUawCalledAgentsRequest = {
    period?: KiteAnalyticsUawCalledAgentsRequest.period;
};

export namespace KiteAnalyticsUawCalledAgentsRequest {

    export enum period {
        D7 = 'D7',
        D30 = 'D30',
        D90 = 'D90',
        ALL = 'ALL',
    }


}

